<template>
  <div class="relative mt-12 p-6 fill-current"
    :class="{ 'bg-red-100': answer_submitted && !check_result() && answer_submitable,
              'bg-green-100': answer_submitted && check_result(),
              'bg-gray-100': !answer_submitted
            }">
    <!-- {{quiz_blocks_status}} -->

    <div v-if="answer_submitted && check_result()"
         class="absolute right-0 top-0 -m-4 text-green-600 fill-current">
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4.393 7.5l-5.643 5.784-2.644-2.506-1.856 1.858 4.5 4.364 7.5-7.643-1.857-1.857z"/></svg>
    </div>

    <div v-if="answer_submitted && !check_result()"
         class="absolute right-0 top-0 -m-4 text-red-600 fill-current">
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.538l-4.592-4.548 4.546-4.587-1.416-1.403-4.545 4.589-4.588-4.543-1.405 1.405 4.593 4.552-4.547 4.592 1.405 1.405 4.555-4.596 4.591 4.55 1.403-1.416z"/></svg>
    </div>

    <h2>{{ block.title }}</h2>
    <h3 class="mb-6">{{ block.teaser }}</h3>

    <div v-for="(a, idx) in question.answers" :key="idx">
      <div class="flex mt-3 text-xl">
        <div v-if="question.type == 'radio'"
             class="items-center cursor-pointer"
             @click.stop="mark(a)">
          <button class="flex">
            <div>
              <radio-checked v-if="marked(a)"></radio-checked>
              <radio-empty v-else></radio-empty>
            </div>
            <span class="ml-2 text-left">
              {{ a.q }}
            </span>
          </button>
        </div>
        <div v-if="question.type == 'checkbox'"
          class="items-center cursor-pointer"
          @click.stop="mark(a)">
          <button class="flex">
            <div>
              <checkbox-checked v-if="marked(a)" class="w-10"></checkbox-checked>
              <checkbox-empty v-else class="w-10"></checkbox-empty>
            </div>
            <span class="ml-2 text-left">
              {{ a.q }}
            </span>
          </button>
        </div>
      </div>
    </div>

    <div v-if="display_submit"
         class="mt-4 flex justify-center">
      <button v-if="!answer_submitted"
              @click="submit_result"
              class="px-4 py-3 text-white rounded-sm"
              :class="{ 'bg-blue-400': !answer_submitted && answer_submitable,
                        'bg-gray-300 cursor-not-allowed': answer_submitted || !answer_submitable }">
        Antwort abgeben
      </button>
      <button v-if="answer_submitted"
              @click="reset_result"
              class="px-4 py-3 rounded-sm bg-white text-gray-800 hover:bg-blue-400">
        Neuer Versuch
      </button>
    </div>

    <pre v-if="debug" class="mt-12">
      {{ block }}
      {{ current_quiz_blocks_status( block.id ) }}
      <!-- {{ question }} -->
      <!-- {{ answers }} -->
      {{ gotten_points + 0 }}
    </pre>
  </div>
</template>

<script>
import EventBus from '../../api/event-bus'

import { mapActions, mapGetters, mapState } from 'vuex'
import RadioChecked from '../picto/radio-checked.vue'
import RadioEmpty from '../picto/radio-empty.vue'
import CheckboxChecked from '../picto/checkbox-checked.vue'
import CheckboxEmpty from '../picto/checkbox-empty.vue'

export default {
  data() {
    return {
      debug: false,
      display_submit: true,
      question: {},
      points: 0.0,
      gotten_points: 0.0,
      type: null,
      answers: [],
      answer_submitted: false
    }
  },
  props: [ 'block' ],
  async created() {
    this.question = JSON.parse( this.block.content )
    this.points = parseFloat( this.question.points )
    this.type = this.question.type

    let stored_data = this.current_quiz_blocks_status( this.block.id )
    if( stored_data ) {
      this.gotten_points = stored_data.reached_points
      this.answers = stored_data.answers || []
      this.answer_submitted = stored_data.done
    } else {
      this.answers = []
    }

    EventBus.on("submit_result", (status) => {
      this.submit_result()
    })

    EventBus.on("display_submit", (status) => {
      // console.log("display_submit", status)
      this.display_submit = status
    })

    EventBus.on("reset_result", () => {
      // console.log("reset_result")
      this.gotten_points = 0.0
      this.answers = []
      this.answer_submitted = false

      this.update_quiz_status({
        id: this.block.id,
        points: this.gotten_points,
        done: false,
        answers: []
      })
    })
  },
  methods: {
    ...mapActions(['update_quiz_status']),
    reset_result() {
      EventBus.emit('reset_result')
    },
    submit_result() {
      let my_points = this.points
      let part_point = this.points / this.question.answers.length
      this.question.answers.forEach( all_a => {
        // console.log( 'all_a', all_a )
        let found = this.answers.find( my_a => my_a.q == all_a.q )
        if( !found && all_a.a === true ) {
          my_points -= part_point
        } else if( found && all_a.a === false ) {
          my_points -= part_point
        }
        my_points = Math.round(my_points*100)/100
      })

      if( this.answers && this.answers.length <= 0 ) {
        this.gotten_points = 0
      } else {
        this.gotten_points = Math.max( my_points, 0 )
      }

      this.update_quiz_status({
        id: this.block.id,
        points: this.gotten_points,
        answers: this.answers
      })
      this.answer_submitted = this.answers.length > 0
    },
    check_result() {
      // console.log( 'check_result-----------------------' )
      // console.log( 'question', this.question )
      // console.log( 'question.answers', this.question.answers )
      // console.log( 'answers', this.answers )
      // console.log( 'points', this.gotten_points, this.points )

      if( !this.answer_submitted || ! this.question || ! this.question.answers || !this.answers ) return false

      return this.gotten_points === this.points
    },
    mark(answer) {
      if( this.answer_submitted ) return

      let found = this.answers.find( a => a.q == answer.q && a.a == answer.a )
      if( found ) {
        this.answers.splice(this.answers.indexOf(found), 1)
      } else {
        if( this.type == 'radio' ) this.answers = []
        this.answers.push( answer )
      }
    },
    marked(answer) {
      // console.log( answer.a, answer.q )
      return this.answers.find( a => a.q == answer.q && a.a == answer.a )
      // return this.answers.find( a => a == answer )
    },
  },
  computed: {
    ...mapState(['quiz_blocks_status']),
    ...mapGetters(['sub_blocks', 'current_quiz_blocks_status']),
    answer_submitable() {
      return this.answers.length > 0
    },
    get_quiz_blocks() {
      return this.sub_blocks( this.block.id )
    }
  },
  components: {
    RadioChecked,
    RadioEmpty,
    CheckboxChecked,
    CheckboxEmpty
  }
}
</script>